const state = {
  appoint: false, // 跳转页面来自预约页面
  showPreUpload: false, //进入预授权申请时，是否展示上传组件
  showCliUpload: false //进入理赔申请时，是否展示上传组件
}
const mutations = {
  setPreUpload(state, str) {
    state.showPreUpload = str
  },
  setappoint(state, str) {
    state.appoint = str
  },
  setCliUpload(state, str) {
    state.showCliUpload = str
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
